if (!customElements.get('cls-product-card')) {
  customElements.define(
    'cls-product-card',
    class extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.addEventListener('click', () => {
          location.href = this.getAttribute('data-url');
        });
        this.querySelectorAll('.cls-swatch').forEach((swatch) => {
          swatch.addEventListener('click', (e) => {
            e.stopPropagation();

            if (swatch.getAttribute('data-swatch')) {
              localStorage.setItem('swatch-redirect', swatch.getAttribute('data-swatch'));
            }

            location.href = swatch.getAttribute('data-href');
          });
        });
        this.querySelectorAll('.jdgm-prev-badge__text').forEach((badge) => {
          const count = Number(badge.innerText.match(/\d+/));

          badge.innerText = `(${count.toLocaleString()})`;
        });
      }
    }
  );
} 